module.exports = __webpack_public_path__ + "img/france-other-heart-diseases-male.d46ab8b4.png";